import Image from "@Components/Image";
import styles from "./StaticNav.module.scss";
import HamburgurIcon from "@Icons/HamburgurIcon";
import gtagEventEmitter from "helpers/gtagEventEmitter";
import { COMPONENTS_CATEGORY, EVENT_LABEL } from "constants/index";
import { PAGE } from "constants/configConstants";
import { Suspense, useState } from "react";
import Portal from "@Components/Portal";
import Modal from "@Components/Modal";
import FullPageLoader from "@Components/FullPageLoader";
import DropdownMenu from "@Components/Header/DropDownMenu";
import CustomLink from "@Components/CustomLink";
import wrapperHOC from "@Utils/wrapperHOC";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import useIsApp from "hooks/useIsApp";

const StaticNav = ({
  absolute = false,
  isHomepage = false,
  isReferralPage = false,
  isAmberPlusHeader = false,
  isLottieBasedFestBg = false,
}: {
  absolute?: boolean;
  isHomepage?: boolean;
  isReferralPage?: boolean;
  isAmberPlusHeader?: boolean;
  isLottieBasedFestBg?: boolean;
}) => {
  const [showSideMenu, setShowSideMenu] = useState(false);
  const isApp = useIsApp();
  const handleEventEmitter = ({ action, label = "", ...rest }: any) => {
    gtagEventEmitter({
      action,
      category: COMPONENTS_CATEGORY.TOP_NAV,
      label: `${PAGE.SEARCH} ${label}`,
      ...rest,
    });
  };
  const handleOnHamburger = () => {
    setShowSideMenu(true);
    handleEventEmitter({ action: EVENT_LABEL.MENU_CLICKED });
  };
  const handleLogoClick = () => {
    gtagEventEmitter({ action: "clicked_amber", category: "" });
  };

  return (
    <div
      className={formatClassNames(
        styles.staticNav,
        absolute && styles.absolute,
        isHomepage && styles.homepage,
      )}
      style={isLottieBasedFestBg ? { background: "none" } : {}}
    >
      <div className={styles.logoLeft}>
        <CustomLink to="/" onClick={handleLogoClick} className={styles.logoIcon}>
          <Image
            src="https://prod-static-assets.amberstudent.com/images/logo/amber-logo-light.svg?auto=format"
            height={20}
            width={83.33}
          />
        </CustomLink>
      </div>

      {!isApp && (
        <div className={styles.rightSection}>
          <i
            data-testid="homepage-topnavbar-hamburger-icon"
            className={styles.hamburger}
            role="none"
            onClick={handleOnHamburger}
          >
            <HamburgurIcon fill="#ffffff" />
          </i>
        </div>
      )}

      {showSideMenu && (
        <Portal rootId="forPortal">
          <Modal
            hideModal={() => setShowSideMenu(false)}
            size="fullScreen"
            animation="bottomToTop"
            isHistoryPush
            type="sideMenu"
          >
            <Suspense fallback={<FullPageLoader />}>
              <DropdownMenu
                showAppBanner={false}
                handleEventEmitter={handleEventEmitter}
                isReferralPage={isReferralPage}
                isAmberPlusHeader={isAmberPlusHeader}
              />
            </Suspense>
          </Modal>
        </Portal>
      )}
    </div>
  );
};

export default wrapperHOC(StaticNav, {
  componentName: "StaticNav-HeroSection-Home",
  showForChina: true,
});
